<app-loading-overlay></app-loading-overlay> <router-outlet></router-outlet>
